import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { GET } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  FETCH_DOCUMENTS_FAILURE,
  FetchPdfUrlActionType,
  FETCH_PDF_URL,
  FETCH_PDF_URL_SUCCESS
} from 'src/redux/documentsReducer'

interface Response {
  pdf_url: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchDocumentPdfFlow(action: FetchPdfUrlActionType): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const endpoint = `/dealers_api/documents/${action.payload.id}/pdf_url`
    const response: Response = yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: GET,
      params: {
        type: action.payload.document_type
      }
    })
    yield put(
      FETCH_PDF_URL_SUCCESS({
        pdf_url: response.pdf_url
      })
    )
  } catch (error) {
    yield put(FETCH_DOCUMENTS_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchDocumentPdfSaga(): Generator<any, void, any> {
  yield takeLatest(FETCH_PDF_URL, FetchDocumentPdfFlow)
}
